// extracted by mini-css-extract-plugin
export default {"average":"Average_average__sz6R0"};